import { RelatedToType } from '@shared/enums';
import { ApprovalStatus, ApproverRequestItem } from '@shared/modules/approvals/approvals.types';
import { ApprovalPanelItem } from '../approvals.types';

export namespace Approvals {
  export class SetRelatedTo {
    static readonly type = '[Approvals] Set Related To';
    constructor(
      public readonly relatedToId: number,
      public readonly relatedToType: RelatedToType,
    ) {}
  }

  export class LoadApprovals {
    static readonly type = '[Approvals] Load Approvals';
  }

  export class LoadEligibleApprovers {
    static readonly type = '[Approvals] Load Eligible Approvers';
  }

  export class AddApproval {
    static readonly type = '[Approvals] Add Approval';
    constructor(
      public readonly name: string,
      public readonly templateId: number | null,
      public readonly snapshot: Record<string, any> = {},
      // used when the approval does not start from a template
      public readonly layout: ApprovalPanelItem[] = [],
    ) {}
  }

  export class SetActiveApproval {
    static readonly type = '[Approvals] Set Active Approval';
    constructor(public readonly approvalId: number) {}
  }

  export class DeleteApproval {
    static readonly type = '[Approvals] Delete Approval';
    constructor(public readonly id: number) {}
  }

  export class UpdateLayout {
    static readonly type = '[Approvals] Update Layout';
    constructor(
      public readonly approvalId: number,
      public readonly layout: ApprovalPanelItem[],
    ) {}
  }

  export class SendApprovalRequest {
    static readonly type = '[Approvals] Send Approval Request';
    constructor(
      public readonly approvalId: number,
      public readonly approvers: ApproverRequestItem[],
    ) {}
  }

  export class UpdateSnapshot {
    static readonly type = '[Approvals] Update Snapshot';
    constructor(
      public readonly approvalId: number,
      public readonly snapshot: Record<string, any>,
    ) {}
  }

  export class UpdateName {
    static readonly type = '[Approvals] Update Name';
    constructor(
      public readonly approvalId: number,
      public readonly name: string,
    ) {}
  }

  export class RefreshApproval {
    static readonly type = '[Approvals] Refresh Approval';
    constructor(public readonly id: number) {}
  }

  export class SubmitReview {
    static readonly type = '[Approvals] Submit Review';
    constructor(
      public readonly approvalRowId: number,
      public readonly status: ApprovalStatus,
      public readonly comments: string,
    ) {}
  }

  export class Reset {
    static readonly type = '[Approvals] Reset';
  }
}
